import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { AdminCompaniesPage, EditCompanyPage } from '../pages/admin';

export const routes = (
  <>
    <Route
      path="/admin/companies"
      element={
        <PrivateRoute>
          <AdminCompaniesPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/admin/companies/edit/:companyId/:tab?"
      element={
        <PrivateRoute>
          <EditCompanyPage />
        </PrivateRoute>
      }
    />
  </>
);
